/**
 * BulkAnimalsTableV16 - v16 Handsontable table component for bulk animal editing
 * Uses v16 editors, validators, and renderers following the TreatmentGroupsTableV16 pattern
 */
import type { FC, RefObject } from 'react';

import type { MetadataField } from '@/model/Metadata.model';

import SpreadsheetV16 from '@/components/UI/SpreadSheet/SpreadsheetV16';
import type { SpreadsheetV16Settings } from '@/components/UI/SpreadSheet/SpreadsheetV16.model';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTableV16';
import { defaultMetadataToColumnSettingMapperV16 } from '@/support/hot-v16';

interface BulkAnimalsTableV16Props {
  data: Array<Record<string, unknown>>;
  settings: SpreadsheetV16Settings;
  innerRef: RefObject<HotTableRef>;
  metadata: Array<MetadataField>;
  setMetadata: (metadata: Array<MetadataField>) => void;
  setInvalid: (invalid: boolean) => void;
  maxRows: number;
}

const BulkAnimalsTableV16: FC<BulkAnimalsTableV16Props> = ({
  data,
  settings,
  innerRef,
  metadata,
  setMetadata,
  setInvalid,
  maxRows,
}) => {
  return (
    <SpreadsheetV16
      className="pl4 pr4"
      testPrefix="bulk-animals-v16"
      data={data}
      innerRef={innerRef}
      settings={settings}
      metadata={metadata}
      setMetadata={setMetadata}
      setInvalid={setInvalid}
      metadataToColumnSettingMapper={defaultMetadataToColumnSettingMapperV16}
      maxRows={maxRows}
    />
  );
};

export default BulkAnimalsTableV16;
